import { render, staticRenderFns } from "./SalesMainIndicatorButton.vue?vue&type=template&id=ede9b83a&scoped=true&"
import script from "./SalesMainIndicatorButton.vue?vue&type=script&lang=js&"
export * from "./SalesMainIndicatorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede9b83a",
  null
  
)

export default component.exports